import { AlertCircle } from '@sparemin/blockhead';
import styled from 'styled-components';

export const AlertIcon = styled(AlertCircle)`
  width: 100px;
  height: 100px;
  color: ${({ theme }) => theme.palette.danger};
`;
